export * from './src/bookings-services-v2-service-services.meta.js';
